<template>
	<div id="addprize" class="page">
		<div class="form-group">
			<div class="form-line" v-on:click="addressPickerShow = true">
				<label>恭喜学员</label>
				<input type="text" v-model="name" style="width:50vw" v-on:input="event_input" placeholder="请输入学员姓名"/>
				<router-link :to="{path:'/prizeuser'}">
					<button>选择学员</button>
				</router-link>
			</div>
			<div class="form-line" v-on:click="kemuPicker = true">
				<label>你通过了</label>
				<div class="form-block">
					<span v-on:click="changeKm('科目一')" v-bind:class="{active:this.km == '科目一'}">科目一</span>
					<span v-on:click="changeKm('科目二')" v-bind:class="{active:this.km == '科目二'}">科目二</span>
					<span v-on:click="changeKm('科目三')" v-bind:class="{active:this.km == '科目三'}">科目三</span>
					<span v-on:click="changeKm('科目四')" v-bind:class="{active:this.km == '科目四'}">科目四</span>
				</div>
			</div>
			<div class="form-line">
				<label>显示打赏</label>
				<div class="form-block">
					<wv-switch title="" v-model="ds"></wv-switch>
				</div>
			</div>
			<router-link :to="{path:'/prizelist'}">
				<div class="form-line big">
				
					<label>奖状样式</label>
					<div class="form-block">
						<div class="l">
							<img v-bind:src="defaultPrize.image"/>
						</div>
						<div><i class="iconfont icon-right"></i></div>
					</div>
				
				</div>
			</router-link>
		</div>
		<div class="btn" v-on:click="event_submit">
			生成奖状
		</div>
		<router-link :to="{path:'/prizesend'}">
			<div class="notice">查看已颁奖状</div>
		</router-link>
	</div>
</template>

<script>
import { Toast } from 'we-vue'
export default {
  data () {
    return {
		name:'',
		user_id:0,
		km:'科目一',
		ds:true,
		defaultPrize:{}
	}
  },
  beforeRouteLeave(to, from, next){
	if(to.name == 'Prizelist' || to.name == 'Prizeuser'){
		this.$route.meta.keepAlive = true
	}else{
		this.$route.meta.keepAlive = false
	}
	next()
  },
  beforeRouteEnter (to, from, next) {
		console.log('显示')
		console.log(from)
		
		next(vm => {
			if(from.name == 'Prizelist' && vm.$store.state.prizeChecked){
				vm.defaultPrize = vm.$store.state.prizeChecked
				vm.$store.state.prizeChecked = null
			}
			if(from.name == 'Prizeuser' && vm.$store.state.prizeUserChecked){
				vm.name = vm.$store.state.prizeUserChecked.nickname
				vm.user_id = vm.$store.state.prizeUserChecked.id
				vm.$store.state.prizeUserChecked = null
			}
		})
  },
  mounted () {
	if(!this.$store.state.userInfo.driver_level.prize){
		this.$wx.showToast('您没有给学员发奖状的权限')
		this.$router.push('/News')
		return false;
	}
  },
  created(){
	this.$app.pr('api/prize/lists').then((res) => {
		this.defaultPrize = res.data.defaultPrize
		
	})
  },
  methods:{
	  	event_submit(){
			if(this.name == ''){
				this.$wx.showToast('请输入学员姓名');
				return false;
			}
			this.$app.pr('api/prize/add',{
				name:this.name,
				user_id:this.user_id,
				prize_id:this.defaultPrize.id,
				ds:this.ds ? 1 : 0,
				km:this.km
			}).then((res) => {
				this.$router.push({path:'/prizeinfo',query:{id:res.data}});
			})
		},
		kemuConfirm(v,t){
			console.log(v);
		},
		changeKm(km){
			this.km = km
		},
		event_input(){
			this.user_id=0
		}
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	.form-group .form-line label{
		font-size:4.2;
	}
	input{
		font-size:4vw;
	}
	#addprize{
		background-color:#f4fcff;
		min-height:100vh;
	}
	.form-line button{
		background:linear-gradient(to right, #fa8d60, #e76025);
		border:0px;
		font-size:3.6vw;
		color:#FFFFFF;
		margin:1.5vw 0vw;
		margin-left:3vw;
	}
	.form-block img{
		height:20vw;
		width:25vw;
		margin:3vw 0vw;
	}
	.form-block div{
		width:5vw;
		line-height:26vw;
	}
	.form-block .l{
		flex:1;
		-webkit-flex:1;
		text-align:right;
	}
	.form-group .form-line.big label{
		line-height:26vw;
	}
	.form-group{
		
	}
	.notice{
		font-size:3.6vw;
		color:#898989;
		text-align:center;
	}
	.form-group .form-line{
		width:100%;
		display:flex;
		display:-webkit-flex;
		background-color:#FFFFFF;
		padding:0px 3vw;
		margin:1.5vw 0vw;
		margin-bottom:3vw;
	}
	.form-group .form-line label{
		display:inline-block;
		width:20vw;
		font-size:4.2vw;
		color:#898989;
		line-height:12vw;
	}
	.form-group .form-line input{
		height:12vw;
		border:0px;
		color:#5d5d5d;
		text-align:right;
	}
	.form-group .form-line textarea{
		height:20vw;
		border:0px;
		color:#5d5d5d;
		text-align:right;
		padding:5px 0px;
		line-height:7vw;
	}
	.form-group .form-line input,.form-group .form-line textarea{
		flex:1;
		-webkit-flex:1;
	}
	.btn{
		height:12vw;
		display:block;
		margin:5vw 3vw;
		text-align:center;
		color:#FFFFFF;
		background:linear-gradient(to right, #fa8d60, #e76025);
		font-size:4vw;
		line-height:12vw;
		border-radius:10px;
	}
	.form-block{
		flex:1;
		-webkit-flex:1;
		text-align:right;
		display:flex;
		display:-webkit-flex;
		position:relative;
	}
	.form-block span{
		flex:1;
		-webkit-flex:1;
		line-height:6vw;
		margin:3vw 1.5vw;
		border-radius:3vw;
		border:1px solid #DDDDDD;
		text-align:center;
		color:#898989;
	}
	.form-block span.active{
		background:linear-gradient(to right, #fa8d60, #e76025);
		color:#FFFFFF;
	}
	.form-block .weui-cell{
		padding:0vw;
		float:right;
		position:absolute;
		right:10vw;
		top:1.5vw;
	}
	button{
		width:24vw;
	}
</style>


// WEBPACK FOOTER //
// src/components/Addprize.vue